/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ShowWoyofalCodesMutationVariables = {
    walletId: string;
};
export type ShowWoyofalCodesMutationResponse = {
    readonly showWoyofalCodes: {
        readonly billTransfers: ReadonlyArray<{
            readonly id: string;
            readonly sendAmount: string;
            readonly whenCreated: string;
            readonly code: string | null;
        } | null>;
    } | null;
};
export type ShowWoyofalCodesMutation = {
    readonly response: ShowWoyofalCodesMutationResponse;
    readonly variables: ShowWoyofalCodesMutationVariables;
};



/*
mutation ShowWoyofalCodesMutation(
  $walletId: ID!
) {
  showWoyofalCodes(walletId: $walletId) {
    billTransfers {
      id
      sendAmount
      whenCreated
      code
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "walletId",
        "variableName": "walletId"
      }
    ],
    "concreteType": "ShowWoyofalCodes",
    "kind": "LinkedField",
    "name": "showWoyofalCodes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillTransfer",
        "kind": "LinkedField",
        "name": "billTransfers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sendAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "whenCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShowWoyofalCodesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShowWoyofalCodesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e384a3caa241e5050949b236db9d16c0",
    "id": null,
    "metadata": {},
    "name": "ShowWoyofalCodesMutation",
    "operationKind": "mutation",
    "text": "mutation ShowWoyofalCodesMutation(\n  $walletId: ID!\n) {\n  showWoyofalCodes(walletId: $walletId) {\n    billTransfers {\n      id\n      sendAmount\n      whenCreated\n      code\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ad6cceea4ea1b8ef8da122702c7a96fc';
export default node;
